function Icon() {
  return (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='60' height='60' rx='8' fill='#E6F0FF' />
      <path
        opacity='0.4'
        d='M37.5 25.5C34.5 25.5 33 24 33 21V16.5H24C21 16.5 19.5 18 19.5 21V39C19.5 42 21 43.5 24 43.5H37.5C40.5 43.5 42 42 42 39V25.5H37.5Z'
        fill='#2A64F6'
      />
      <path d='M37.5 25.5H42L33 16.5V21C33 24 34.5 25.5 37.5 25.5Z' fill='#2A64F6' />
      <path
        d='M32.2962 32.2055L29.2962 29.2055C29.1927 29.102 29.068 29.0195 28.93 28.9625C28.6555 28.8485 28.345 28.8485 28.0705 28.9625C27.9325 29.0195 27.8081 29.102 27.7046 29.2055L24.7046 32.2055C24.2651 32.645 24.2651 33.3575 24.7046 33.797C25.1441 34.2365 25.8567 34.2365 26.2962 33.797L27.3761 32.717V37.5005C27.3761 38.1215 27.8801 38.6255 28.5011 38.6255C29.1221 38.6255 29.6261 38.1215 29.6261 37.5005V32.717L30.7061 33.797C30.9251 34.016 31.2131 34.127 31.5011 34.127C31.7891 34.127 32.0772 34.0175 32.2962 33.797C32.7357 33.3575 32.7357 32.6435 32.2962 32.2055Z'
        fill='#2A64F6'
      />
    </svg>
  );
}

export default Icon;
